
// ============================================
// WhoWeAreScene - 会社紹介ページシーン
// ============================================

/**
 * GNS.WhoWeAreScene
 * * 会社紹介ページ（/who_we_are/）のメイン制御クラス
 */
GNS.WhoWeAreScene = function (GNS) {
    // AbstractSceneを継承
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        // フラグ・プロパティ設定
        this.scrollEnabled = true;
        this.isMove = false; // 元コードにありましたが、使用箇所不明（親クラス用？）

        // UI要素の取得
        this.ui = {
            text1: new GNS.DisplayObject("who_we_are__message__item__text1"),
            text2: new GNS.DisplayObject("who_we_are__message__item__text2")
        };

        // 管理配列
        this.memberButtons = [];   // チームメンバーのサムネイルボタン (旧 playerArray)
        this.businessColumns = []; // 事業紹介カラム (旧 ourbusinessPages)

        // ヘッダーイベントの監視
        this._bindHeaderEvents(true);
    };

    /**
     * ロード処理
     */
    scene.load = function () {
        this.isLoading = true;
        this._loadComplete();
    };

    /**
     * ロード完了時の実処理
     * 各種サブコンポーネントの初期化を行う
     */
    scene._bind._loadComplete = function () {
        // 1. 事業紹介カラム（OurBusinessOverviewColumn）の動的初期化
        this._initBusinessColumns();

        // 2. チームメンバーリスト（UIThumBtn）の初期化
        this._initTeamMembers();

        // 親クラスのload完了処理
        scene._super.load.call(this);
    };

    /**
     * 事業紹介カラムの初期化ヘルパー
     */
    scene._initBusinessColumns = function () {
        const columns = this.element.querySelectorAll(".ourbusiness__overview__column");

        Array.from(columns).forEach(col => {
            if (!col.id) return;

            const page = new GNS.OurBusinessOverviewColumn(col.id, this);
            this.businessColumns.push(page);

            // ロード完了後に表示
            page.addEventListener(GNS.Event.LOAD, () => {
                page.show();
            });
            page.load();
        });
    };

    /**
     * チームメンバーリストの初期化ヘルパー
     */
    scene._initTeamMembers = function () {
        const teamLists = this.element.querySelectorAll(".who_we_are__team__list");

        // リストごとのループ
        Array.from(teamLists).forEach((list, listIndex) => {
            const items = list.querySelectorAll(".who_we_are__team__list__item");

            // アイテムごとのループ
            Array.from(items).forEach((itemNode) => {
                const itemObj = new GNS.DisplayObject(itemNode);
                const linkNode = itemNode.querySelector(".item__link");

                // 元コードにあった `j` (画像コンテナ?) は常にnullだったため、
                // ここでは null を直接渡す形に整理しています。
                // 引数: (linkElement, bgElement, imgObj, containerObj, ???, delay)
                const thumbBtn = new GNS.UIThumBtn(
                    linkNode,
                    null,
                    null,
                    itemObj,
                    null,
                    0.05 * listIndex // リストのインデックスに応じて遅延を設定
                );

                this.memberButtons.push(thumbBtn);
            });
        });
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () {
        // 必要に応じて実装
    };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () {
        this._bindHeaderEvents(false);
    };

    /**
     * リセットハンドラ
     * 生成したメンバーボタンなどを破棄する
     */
    scene.resetHandler = function () {
        this.memberButtons.forEach(btn => {
            if (btn.kill) btn.kill();
        });
        this.memberButtons = [];
    };

    /**
     * ヘッダーイベントのバインド/アンバインド
     */
    scene._bindHeaderEvents = function (shouldBind) {
        const header = GNS.Header.getInstance();
        const method = shouldBind ? "addEventListener" : "removeEventListener";

        header[method]("nav_open", this.openedMenu);
        header[method]("nav_close", this.closedMenu);
    };

    /**
     * メニューが開いた時の処理
     */
    scene._bind.openedMenu = function () {
        this.scrollEnabled = false;
    };

    /**
     * メニューが閉じた時の処理
     */
    scene._bind.closedMenu = function () {
        this.scrollEnabled = true;
    };

    /**
     * スクロールハンドラ
     */
    scene.scrollHandler = function () {
        if (this.scrollEnabled) {
            // 元のコードには計算式 `b.scrollY / c` がありましたが、
            // 計算結果を変数に代入も使用もしていなかったため、実質何もしないコードでした。
            // パララックス等の処理が必要な場合はここに記述します。

            /*
            const pageSize = GNS.DOM.getPageSize();
            const docHeight = GNS.Document.getInstance().displayHeight;
            const scrollRatio = pageSize.scrollY / docHeight;
            // console.log(scrollRatio);
            */
        }
    };

    return scene._self;
}(GNS);
